<mat-form-field appearance="outline"
                floatLabel="always"
                id="select-component-root"
                class="select-component-root"
                [ngClass]="{small}">
  <mat-label>{{label}}</mat-label>
  <mat-select [formControl]="control"
              disableOptionCentering
              panelClass="panel-options"
              (openedChange)="handleOpenChange()"
              [value]="value"
              [placeholder]="placeholder || ''"
              (selectionChange)="changeSelect()"
              [disabled]="disabled">
    <mat-option *ngFor="let option of options"
                [value]="hasIdAndValue ? isValueString ? option.name : option.id : option">
      {{hasIdAndValue ? option.name : option}}
    </mat-option>
  </mat-select>
  <div matSuffix>
    <mat-icon class="select-icon-less" *ngIf="panelIsOpen">expand_less</mat-icon>
    <mat-icon class="select-icon-more" *ngIf="!panelIsOpen">expand_more</mat-icon>
  </div>
  <mat-error>{{errorMessage}}</mat-error>
</mat-form-field>
